import { ShieldCheck, EyeOff, Lock, UserRoundCheck } from 'lucide-react';
import Reveal from './Reveal';

const points = [
  { icon: EyeOff, head: 'No public listings', sub: 'Nothing is indexed, browsed or scraped. Invite-only, always.' },
  { icon: UserRoundCheck, head: 'Supplier identity stays hidden', sub: 'Buyers see the listing and the price. Never your source.' },
  { icon: Lock, head: 'Buyer activity is never sold', sub: 'Interest goes back to the sender of that menu. Nowhere else.' },
  { icon: ShieldCheck, head: 'Your book stays your book', sub: 'Company-scoped by default. You choose who sees what.' },
];

const PrivacySection = () => (
  <section id="private" className="scroll-mt-16 border-b border-white/10 bg-foreground py-20 text-background md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">Private by design</h2>
        <p className="mt-4 text-lg text-background/70">
          Discretion is the business. We built for it first, not later.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {points.map((p, i) => (
          <Reveal key={p.head} delay={i * 80}>
            <div className="h-full rounded-xl border border-white/10 bg-white/[0.03] p-6">
              <p.icon className="h-5 w-5 text-brand" aria-hidden="true" />
              <p className="mt-4 font-medium">{p.head}</p>
              <p className="mt-2 text-sm text-background/60">{p.sub}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default PrivacySection;